<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <!-- <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;width:100%">
      <h5 style="float:left;"><span style="padding-right:15px"></span><b> Manage {{this.lblHeading}}</b></h5>
      <span class="places-desc">
        For : <span class="country-name">Country Code : {{selectCountry.code}}</span> , <span class="cntry-desc">Country
          Description : {{selectCountry.desc}}</span>
      </span>
    </div>
  </div> -->

  <div class="flex-row flex">
    <h4 class="title">Manage {{this.lblHeading}}</h4>
  </div>
  
  <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display">Filters</legend>
    <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important;">
      <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
        <table class="" style="width:100%!important;margin:0px;padding:0px;" border="0">
          <tr class="rmp-all">
            <td style="width:18%!important;vertical-align:top!important; padding-right: 30px;">
              <select class="form-control form-control-sm" [(ngModel)]="selectedProvince"
                (change)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)">
                <option [ngValue]="0" selected>All provinces</option>
                <option *ngFor="let item of countryProvinces" [ngValue]="item.id">{{item.description}}</option>
              </select>
            </td>
            <td style="vertical-align:top!important;width:22%!important;  padding-right: 30px;">
              <input type="text" style="margin:0px;padding-left:5px;" [(ngModel)]="filterQuery"
                (keyup)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)"
                (change)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)" placeholder="Search places"
                class="form-control form-control-sm" />
            </td>
            <td style="vertical-align:top!important;width:22%!important;">
              <div class="row" style="margin:1px 1px 0 1px;padding:0px 1px 0 1px;">
                <div class="col-4 rmp-all-c text-right">Show only &nbsp;</div>
                <div class="col-6 rmp-all">
                  <div class="col-6 rmp-all-c text-right" style="position: relative;">Border Post: &nbsp; <input
                      #borderPostCheck type="checkbox" (change)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)"
                      style="position: absolute; width: 15px; height: 15px; top: 1px;" /></div>
                  <div class="col-6 rmp-all-c text-right" style="position: relative;">Taxi Rank: &nbsp; <input
                      #taxiRankCheck type="checkbox" (change)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)"
                      style="position: absolute; width: 15px; height: 15px; top: 1px;" /></div>
                  <div class="col-6 rmp-all-c text-right" style="position: relative;">Terminus : &nbsp; <input
                      #terminusCheck type="checkbox" (change)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)"
                      style="position: absolute; width: 15px; height: 15px; top: 1px;" /></div>
                </div>
              </div>
            </td>
            <td style="vertical-align:top!important;width:10%!important;" class="rmp-all">
              <!--Button with tooltip and no label -->
              <div class="cover-x pull-right">
                <div class="main-btn rounded-circle rmp-all"
                  (click)="onReset(borderPostCheck, taxiRankCheck, terminusCheck)" title="Reset filters..."
                  style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                  <span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;"
                    aria-hidden="true"></span>
                </div>
              </div>
              <div class="cover-x">
                <div class="main-btn rounded-circle rmp-all"
                  (click)="onSearch(borderPostCheck,taxiRankCheck,terminusCheck)" title="Apply filters..."
                  style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                  <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;"
                    aria-hidden="true"></span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </fieldset>
  
  <div class="row">
    <button title="Add a New Place"  (click)="navigate('countries/add')"  type="submit" id="btnSave"
            class="btn hd-btn" style="margin-left: 15px;" >Add new</button>
  </div>
  <hr>
  <div class="row">
    <!-- <div *ngIf="isRemove" class="text-danger col-md-12">
      <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
      <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
      <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
    </div> -->
    <div class="col-md-12" *ngIf="!isRemove">
      <table id="pTypes" border="1" class="table tbl-stl">

        <thead class="thead-inverse tbl-hd-stl hgt-btn">
          <tr style="vertical-align:middle;" class="hgt-btn">
            <th>
              Province
              <i style="vertical-align:middle; " class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagPV== 2),'fa-sort-desc sort-d': (utility.flags.flagPV == 3), 'fa-sort':(utility.flags.flagPV == 1) }"
                (click)="utility.onSort(6)"></i>
            </th>
            <th>
              Town/Place
              <i style="vertical-align:middle;" class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
                (click)="utility.onSort(1)"></i>
            </th>
            <th style="vertical-align:middle;">
              Code
              <i style="vertical-align:middle; " class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(1)"></i>
            </th>
            <th style="vertical-align:middle;">
              Name
              <i style="vertical-align:middle;" class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
                (click)="utility.onSort(2)"></i>
            </th>
            <th style="vertical-align:middle;">
              Type
            </th>
            <th style="vertical-align:middle;">
              Longitude
            </th>
            <th style="vertical-align:middle;">
              Latitude
            </th>
            <th style="vertical-align:middle;">Town ?</th>
            <th style="vertical-align:middle;">Border Post ?</th>
            <th style="vertical-align:middle;">Taxi Rank ?</th>
            <th style="vertical-align:middle;">Terminus ?</th>
            <th style="vertical-align:middle;">Active
              <i style="vertical-align:middle; " class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
                (click)="utility.onSort(3)"></i></th>
            <th style="vertical-align:middle; display:none">Sort Order
              <i style="vertical-align:middle; " class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
                (click)="utility.onSort(5)"></i></th>
            <th style="vertical-align:middle; display:none">Group
              <i style="vertical-align:middle; " class="fa fa-chevron-circle-up"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
                (click)="utility.onSort(4)"></i></th>
            <th style="vertical-align:middle; display:none">Display </th>
            <th class="btn-show hgt-btn">
              <!-- <a (click)="navigate('countries/add')" title="" style="width:180px; ">
                <span title="Add a New Place" class=" btn-add btn btn-primary btn-sm"><i class="fa fa-plus fa-2x"
                    aria-hidden="true"></i></span>
              </a> -->
            </th>
          </tr>
        </thead>
        <tr style="height: 10px !important;"
          *ngFor="let list of placesList  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">

          <td>{{getprovinceDesc(list.province_id)}}</td>
          <td>{{getPlaceDesc(list.parent_place_id)}}</td>
          <td>{{list.code}}</td>
          <td>{{list.name}}</td>
          <td>{{list.type}}</td>
          <td>{{list.longitude}}</td>
          <td>{{list.latitude}}</td>
          <td>{{list.is_town}}</td>
          <td>{{list.is_border_post}}</td>
          <td>{{list.is_taxi_rank}}</td>
          <td>{{list.is_terminus}}</td>
          <td>{{list.is_active}}</td>
          <td align="center" style="display:none">{{ list.sort_order}}</td>
          <td align="center" style="display:none">{{ list.group_code}}</td>
          <td style="display:none">{{utility.showDisplayIndicator(list.display_ind)}}</td>
          <td class="btn-show">
            <a (click)="navigateToEdit('countries/edit',list)"><img src="../../../assets/newimg/border-color-13@2x.png" title="Edit Place" style="cursor: pointer;margin: 10px;"/></a>
            <span title="Delete Place" (click)="onConfirm(list)">
            <img src="../../../../../assets/newimg/delete-30@2x.png" title="Delete Place" (click)="onConfirm(list)" style="cursor: pointer;"/>
            </span>
          </td>
        </tr>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="placesList.length > 4" style="padding-left:0px;margin-left:0px;">
            <td colspan="10" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">

                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="showNum" style="">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = $event"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>
            <td colspan="10" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="cover-x pull-right">
                <div class="main-btn rounded-circle rmp-all" routerLink="/countries/list" title="Close"
                  style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                  <span class="fa fa-times fa-2x" style="margin:5.5px auto;color:white!important;"
                    aria-hidden="true"></span>
                </div>
                <div class="lbl-app" style="margin: 1px auto;">
                  <span>Close</span>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="placesList.length==0">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Places found.</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>